// extracted by mini-css-extract-plugin
export var active = "_2p-7";
export var backButton = "_2p-6";
export var clone = "_2p-c";
export var collapseBar = "_2p-h";
export var collapseMode = "_2p-j";
export var collapsed = "_2p-l";
export var dragHandle = "_2p-a";
export var dropdownIcon = "_2p-e";
export var expanding = "_2p-k";
export var hidden = "_2p-r";
export var iconContainer = "_2p-o";
export var iconSwapper = "_2p-q";
export var navItem = "_2p-4";
export var navItemIcon = "_2p-d";
export var navProfile = "_2p-5";
export var notificationCountBadge = "_2p-g";
export var notificationDot = "_2p-p";
export var optionsContainer = "_2p-f";
export var primaryNav = "_2p-0";
export var primaryTab = "_2p-m";
export var secondaryNav = "_2p-1";
export var selected = "_2p-n";
export var settingsNav = "_2p-2";
export var settingsNavItems = "_2p-3";
export var show = "_2p-b";
export var sideNav = "_2p-i";
export var teamItem = "_2p-8";
export var userProfileItem = "_2p-9";